export const shared = {
  toggleLocale: 'English',
  view: 'عرض',
  edit: 'تعديل',
  delete: 'حذف',
  confirm: 'تأكيد',
  cancel: 'إلغاء',
  send: 'إرسال',
  add: 'إضافة',
  download: 'تحميل',
  notFound: 'غير متاح',
  networkError: 'خطأ في الشبكة',
  noData: 'لا توجد بيانات',
  generalErrMsg: 'لقد حدث خطأ ما!',
  save: 'حفظ',
  fileSize: 'حجم الملف',
  copyPhoneNumber: 'نسخ رقم الهاتف',
  copied: 'تم النسخ',
  appBar: {
    logout: 'تسجيل الخروج',
    search: 'ابحث…',
    filters: 'تصنيف',
    block: 'حظر',
    unblock: 'فك الحظر',
    select: 'اختيار',
    import: 'إرفاق',
    reorder: 'رتب',
    reorderHint: 'يتم إعادة الترتيب عن طريق السحب والإفلات.',
    reorderAlert: 'يجب إلغاء اي تصنيف او بحث لإعادة الترتيب.',
  },
  drawer: {
    users: 'المستخدمون',
    singleOwners: "سائق حر",
    fleetOwners: "صاحب أسطول",
    drivers: 'سائق في أسطول',
    rewards: 'الجوائز',
    liveRewards: 'الجوائز المباشرة',
    deletedRewards: 'الجوائز المحذوفة',
    trips: 'الرحلات',
    tripsDrivers:"رحلات السائقين",
    tripsOwners: "رحلات المالكين",
    pendingDrivers: 'سائق منتظر',
    verificationRequests: 'طلبات التحقق',
    pendingRequests: 'الطلبات المعلقة',
    requestsHistory: 'تاريخ الطلبات',
    adminsManagement: 'إدارة المشرفين',
    standardAdmins: 'المشرفون القياسيون',
    referralProgram: 'برنامج الإحالة',
    referralsList: 'قائمة الإحالات',
    referralsRewards: 'مكافآت الإحالة',
    offers: 'العروض',
    animations: 'الرسوم المتحركة',
    services: 'الخدمات',
    serviceCenters: 'مراكز الخدمة',
    marketplace: 'السوق',
    challenges: 'التحديات',
    chat: 'المحادثة',
  },
  filters: {
    noOptions: 'لا يوجد نتائج',
    startDate: 'من',
    endDate: 'إلى',
    clear: 'مسح',
    loading: 'تحميل…',
    from: 'من',
    to: 'إلى',
  },
  upload: {
    cropBanner: 'قص البانر',
    done: 'تأكيد',
    sizeError: 'هذه الصورة تخطت الحد المسموح للحجم  (1ميجابايت)',
    sizeErrorFiveMb: 'هذه الصورة تخطت الحد المسموح للحجم  (5ميجابايت)',
    typeError: 'هذه الصورة ليست من الأنواع المقبولة',
    uploadBanner: 'ارفع البانر',
    sizeHint: 'الحجم المسموح: 15Mb',
    typeHint: 'أنواع الصور المقبولة: JPG, PNG, JPEG',
    cropImg: 'قص الصورة',
    excelTypeHint: 'أنواع الملفات المقبولة: XLSX',
    jsonTypeHint: 'أنواع الملفات المقبولة: JSON',
    fileSizeError: 'هذا الملف تخطي الحد المسموح للحجم  (1ميجابايت)',
    fileTypeError: 'هذا الملف ليس من الأنواع المقبولة',
    invalidAnimationFile: 'ملف الرسم المتحرك غير صالح',
    halfMBFileSizeError: 'هذا الملف تخطي الحد المسموح للحجم  (0.5ميجابايت)',
    invalidJSONFileFormat: 'ملف  غير صالح',
  },
  exportPdf: 'تحميل ملف PDF',
  startLocation: 'موقع البداية',
  endLocation: 'موقع النهاية',
  selectActions: 'حدد الإجراء',
  update: 'تعديل',
  proceed: 'تابع',
  close: 'غلق',
  invalidAnimationFile: 'ملف الرسوم المتحركة غير صالح',
  yes: 'نعم',
  no: 'لا',
  redFlag: {
    columnHeader: 'علامة الاحتيال',
    flagAction: 'وضع علامة احتيال',
    removeAction: 'إزالة العلامة',
    flagTitle: 'وضع علامة احتيال على هذا المستخدم',
    flagBody: 'سيتم تصنيف {name} كمستخدم محتال في جميع أنحاء المنصة.',
    unflagTitle: 'إزالة علامة الاحتيال',
    unflagBody: 'لن يتم تصنيف {name} كمستخدم محتال بعد الآن.',
    reasonPlaceholder: 'سبب وضع العلامة (اختياري)...',
    source: {
      ai: 'ذكاء اصطناعي',
      backend_rule: 'قاعدة نظام',
      manual: 'يدوي',
    },
  },
};
